import { render, staticRenderFns } from "./CustomerListCard.vue?vue&type=template&id=4284c9a5&"
import script from "./CustomerListCard.vue?vue&type=script&lang=js&"
export * from "./CustomerListCard.vue?vue&type=script&lang=js&"
import style0 from "./CustomerListCard.vue?vue&type=style&index=0&id=4284c9a5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports